import { Config } from "src/models";
import { ConfigInitTypes } from "../types";
import { createAction } from "./create.action";

export namespace ConfigInitAction {

    export const showLoading = () => createAction(ConfigInitTypes.SHOW_CONFIG_INIT_LOADING);
    export const hideLoading = () => createAction(ConfigInitTypes.HIDE_CONFIG_INIT_LOADING);

    export const getData = (loginParam?: string | null, iranLeagueParam?: string | null) =>
        createAction(ConfigInitTypes.REQUEST_LOAD_CONFIG_INIT, { loginParam, iranLeagueParam });

    export const setData = (config: Config) => createAction(ConfigInitTypes.SET_CONFIG_INIT_DATA, config);

}